import { api } from '../client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int'];
};

export type AggregateAttestation = {
  __typename?: 'AggregateAttestation';
  _avg?: Maybe<AttestationAvgAggregate>;
  _count?: Maybe<AttestationCountAggregate>;
  _max?: Maybe<AttestationMaxAggregate>;
  _min?: Maybe<AttestationMinAggregate>;
  _sum?: Maybe<AttestationSumAggregate>;
};

export type AggregateEnsName = {
  __typename?: 'AggregateEnsName';
  _avg?: Maybe<EnsNameAvgAggregate>;
  _count?: Maybe<EnsNameCountAggregate>;
  _max?: Maybe<EnsNameMaxAggregate>;
  _min?: Maybe<EnsNameMinAggregate>;
  _sum?: Maybe<EnsNameSumAggregate>;
};

export type AggregateOffchainRevocation = {
  __typename?: 'AggregateOffchainRevocation';
  _avg?: Maybe<OffchainRevocationAvgAggregate>;
  _count?: Maybe<OffchainRevocationCountAggregate>;
  _max?: Maybe<OffchainRevocationMaxAggregate>;
  _min?: Maybe<OffchainRevocationMinAggregate>;
  _sum?: Maybe<OffchainRevocationSumAggregate>;
};

export type AggregateSchema = {
  __typename?: 'AggregateSchema';
  _avg?: Maybe<SchemaAvgAggregate>;
  _count?: Maybe<SchemaCountAggregate>;
  _max?: Maybe<SchemaMaxAggregate>;
  _min?: Maybe<SchemaMinAggregate>;
  _sum?: Maybe<SchemaSumAggregate>;
};

export type AggregateSchemaName = {
  __typename?: 'AggregateSchemaName';
  _avg?: Maybe<SchemaNameAvgAggregate>;
  _count?: Maybe<SchemaNameCountAggregate>;
  _max?: Maybe<SchemaNameMaxAggregate>;
  _min?: Maybe<SchemaNameMinAggregate>;
  _sum?: Maybe<SchemaNameSumAggregate>;
};

export type AggregateServiceStat = {
  __typename?: 'AggregateServiceStat';
  _count?: Maybe<ServiceStatCountAggregate>;
  _max?: Maybe<ServiceStatMaxAggregate>;
  _min?: Maybe<ServiceStatMinAggregate>;
};

export type AggregateTimestamp = {
  __typename?: 'AggregateTimestamp';
  _avg?: Maybe<TimestampAvgAggregate>;
  _count?: Maybe<TimestampCountAggregate>;
  _max?: Maybe<TimestampMaxAggregate>;
  _min?: Maybe<TimestampMinAggregate>;
  _sum?: Maybe<TimestampSumAggregate>;
};

export type Attestation = {
  __typename?: 'Attestation';
  attester: Scalars['String'];
  data: Scalars['String'];
  decodedDataJson: Scalars['String'];
  expirationTime: Scalars['Int'];
  id: Scalars['String'];
  ipfsHash: Scalars['String'];
  isOffchain: Scalars['Boolean'];
  recipient: Scalars['String'];
  refUID: Scalars['String'];
  revocable: Scalars['Boolean'];
  revocationTime: Scalars['Int'];
  revoked: Scalars['Boolean'];
  schema: Schema;
  schemaId: Scalars['String'];
  time: Scalars['Int'];
  timeCreated: Scalars['Int'];
  txid: Scalars['String'];
};

export type AttestationAvgAggregate = {
  __typename?: 'AttestationAvgAggregate';
  expirationTime?: Maybe<Scalars['Float']>;
  revocationTime?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['Float']>;
  timeCreated?: Maybe<Scalars['Float']>;
};

export type AttestationAvgOrderByAggregateInput = {
  expirationTime?: Maybe<SortOrder>;
  revocationTime?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  timeCreated?: Maybe<SortOrder>;
};

export type AttestationCountAggregate = {
  __typename?: 'AttestationCountAggregate';
  _all: Scalars['Int'];
  attester: Scalars['Int'];
  data: Scalars['Int'];
  decodedDataJson: Scalars['Int'];
  expirationTime: Scalars['Int'];
  id: Scalars['Int'];
  ipfsHash: Scalars['Int'];
  isOffchain: Scalars['Int'];
  recipient: Scalars['Int'];
  refUID: Scalars['Int'];
  revocable: Scalars['Int'];
  revocationTime: Scalars['Int'];
  revoked: Scalars['Int'];
  schemaId: Scalars['Int'];
  time: Scalars['Int'];
  timeCreated: Scalars['Int'];
  txid: Scalars['Int'];
};

export type AttestationCountOrderByAggregateInput = {
  attester?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  decodedDataJson?: Maybe<SortOrder>;
  expirationTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipfsHash?: Maybe<SortOrder>;
  isOffchain?: Maybe<SortOrder>;
  recipient?: Maybe<SortOrder>;
  refUID?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  revocationTime?: Maybe<SortOrder>;
  revoked?: Maybe<SortOrder>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  timeCreated?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type AttestationCreateInput = {
  attester: Scalars['String'];
  data: Scalars['String'];
  decodedDataJson?: Maybe<Scalars['String']>;
  expirationTime: Scalars['Int'];
  id: Scalars['String'];
  ipfsHash: Scalars['String'];
  isOffchain: Scalars['Boolean'];
  recipient: Scalars['String'];
  refUID: Scalars['String'];
  revocable: Scalars['Boolean'];
  revocationTime: Scalars['Int'];
  revoked: Scalars['Boolean'];
  schema: SchemaCreateNestedOneWithoutAttestationsInput;
  time: Scalars['Int'];
  timeCreated: Scalars['Int'];
  txid: Scalars['String'];
};

export type AttestationCreateManyInput = {
  attester: Scalars['String'];
  data: Scalars['String'];
  decodedDataJson?: Maybe<Scalars['String']>;
  expirationTime: Scalars['Int'];
  id: Scalars['String'];
  ipfsHash: Scalars['String'];
  isOffchain: Scalars['Boolean'];
  recipient: Scalars['String'];
  refUID: Scalars['String'];
  revocable: Scalars['Boolean'];
  revocationTime: Scalars['Int'];
  revoked: Scalars['Boolean'];
  schemaId: Scalars['String'];
  time: Scalars['Int'];
  timeCreated: Scalars['Int'];
  txid: Scalars['String'];
};

export type AttestationCreateManySchemaInput = {
  attester: Scalars['String'];
  data: Scalars['String'];
  decodedDataJson?: Maybe<Scalars['String']>;
  expirationTime: Scalars['Int'];
  id: Scalars['String'];
  ipfsHash: Scalars['String'];
  isOffchain: Scalars['Boolean'];
  recipient: Scalars['String'];
  refUID: Scalars['String'];
  revocable: Scalars['Boolean'];
  revocationTime: Scalars['Int'];
  revoked: Scalars['Boolean'];
  time: Scalars['Int'];
  timeCreated: Scalars['Int'];
  txid: Scalars['String'];
};

export type AttestationCreateManySchemaInputEnvelope = {
  data: Array<AttestationCreateManySchemaInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type AttestationCreateNestedManyWithoutSchemaInput = {
  connect?: Maybe<Array<AttestationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AttestationCreateOrConnectWithoutSchemaInput>>;
  create?: Maybe<Array<AttestationCreateWithoutSchemaInput>>;
  createMany?: Maybe<AttestationCreateManySchemaInputEnvelope>;
};

export type AttestationCreateOrConnectWithoutSchemaInput = {
  create: AttestationCreateWithoutSchemaInput;
  where: AttestationWhereUniqueInput;
};

export type AttestationCreateWithoutSchemaInput = {
  attester: Scalars['String'];
  data: Scalars['String'];
  decodedDataJson?: Maybe<Scalars['String']>;
  expirationTime: Scalars['Int'];
  id: Scalars['String'];
  ipfsHash: Scalars['String'];
  isOffchain: Scalars['Boolean'];
  recipient: Scalars['String'];
  refUID: Scalars['String'];
  revocable: Scalars['Boolean'];
  revocationTime: Scalars['Int'];
  revoked: Scalars['Boolean'];
  time: Scalars['Int'];
  timeCreated: Scalars['Int'];
  txid: Scalars['String'];
};

export type AttestationGroupBy = {
  __typename?: 'AttestationGroupBy';
  _avg?: Maybe<AttestationAvgAggregate>;
  _count?: Maybe<AttestationCountAggregate>;
  _max?: Maybe<AttestationMaxAggregate>;
  _min?: Maybe<AttestationMinAggregate>;
  _sum?: Maybe<AttestationSumAggregate>;
  attester: Scalars['String'];
  data: Scalars['String'];
  decodedDataJson: Scalars['String'];
  expirationTime: Scalars['Int'];
  id: Scalars['String'];
  ipfsHash: Scalars['String'];
  isOffchain: Scalars['Boolean'];
  recipient: Scalars['String'];
  refUID: Scalars['String'];
  revocable: Scalars['Boolean'];
  revocationTime: Scalars['Int'];
  revoked: Scalars['Boolean'];
  schemaId: Scalars['String'];
  time: Scalars['Int'];
  timeCreated: Scalars['Int'];
  txid: Scalars['String'];
};

export type AttestationListRelationFilter = {
  every?: Maybe<AttestationWhereInput>;
  none?: Maybe<AttestationWhereInput>;
  some?: Maybe<AttestationWhereInput>;
};

export type AttestationMaxAggregate = {
  __typename?: 'AttestationMaxAggregate';
  attester?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  decodedDataJson?: Maybe<Scalars['String']>;
  expirationTime?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  ipfsHash?: Maybe<Scalars['String']>;
  isOffchain?: Maybe<Scalars['Boolean']>;
  recipient?: Maybe<Scalars['String']>;
  refUID?: Maybe<Scalars['String']>;
  revocable?: Maybe<Scalars['Boolean']>;
  revocationTime?: Maybe<Scalars['Int']>;
  revoked?: Maybe<Scalars['Boolean']>;
  schemaId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
  timeCreated?: Maybe<Scalars['Int']>;
  txid?: Maybe<Scalars['String']>;
};

export type AttestationMaxOrderByAggregateInput = {
  attester?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  decodedDataJson?: Maybe<SortOrder>;
  expirationTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipfsHash?: Maybe<SortOrder>;
  isOffchain?: Maybe<SortOrder>;
  recipient?: Maybe<SortOrder>;
  refUID?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  revocationTime?: Maybe<SortOrder>;
  revoked?: Maybe<SortOrder>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  timeCreated?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type AttestationMinAggregate = {
  __typename?: 'AttestationMinAggregate';
  attester?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  decodedDataJson?: Maybe<Scalars['String']>;
  expirationTime?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  ipfsHash?: Maybe<Scalars['String']>;
  isOffchain?: Maybe<Scalars['Boolean']>;
  recipient?: Maybe<Scalars['String']>;
  refUID?: Maybe<Scalars['String']>;
  revocable?: Maybe<Scalars['Boolean']>;
  revocationTime?: Maybe<Scalars['Int']>;
  revoked?: Maybe<Scalars['Boolean']>;
  schemaId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
  timeCreated?: Maybe<Scalars['Int']>;
  txid?: Maybe<Scalars['String']>;
};

export type AttestationMinOrderByAggregateInput = {
  attester?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  decodedDataJson?: Maybe<SortOrder>;
  expirationTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipfsHash?: Maybe<SortOrder>;
  isOffchain?: Maybe<SortOrder>;
  recipient?: Maybe<SortOrder>;
  refUID?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  revocationTime?: Maybe<SortOrder>;
  revoked?: Maybe<SortOrder>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  timeCreated?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type AttestationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type AttestationOrderByWithAggregationInput = {
  _avg?: Maybe<AttestationAvgOrderByAggregateInput>;
  _count?: Maybe<AttestationCountOrderByAggregateInput>;
  _max?: Maybe<AttestationMaxOrderByAggregateInput>;
  _min?: Maybe<AttestationMinOrderByAggregateInput>;
  _sum?: Maybe<AttestationSumOrderByAggregateInput>;
  attester?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  decodedDataJson?: Maybe<SortOrder>;
  expirationTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipfsHash?: Maybe<SortOrder>;
  isOffchain?: Maybe<SortOrder>;
  recipient?: Maybe<SortOrder>;
  refUID?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  revocationTime?: Maybe<SortOrder>;
  revoked?: Maybe<SortOrder>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  timeCreated?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type AttestationOrderByWithRelationInput = {
  attester?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  decodedDataJson?: Maybe<SortOrder>;
  expirationTime?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ipfsHash?: Maybe<SortOrder>;
  isOffchain?: Maybe<SortOrder>;
  recipient?: Maybe<SortOrder>;
  refUID?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  revocationTime?: Maybe<SortOrder>;
  revoked?: Maybe<SortOrder>;
  schema?: Maybe<SchemaOrderByWithRelationInput>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  timeCreated?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export enum AttestationScalarFieldEnum {
  Attester = 'attester',
  Data = 'data',
  DecodedDataJson = 'decodedDataJson',
  ExpirationTime = 'expirationTime',
  Id = 'id',
  IpfsHash = 'ipfsHash',
  IsOffchain = 'isOffchain',
  Recipient = 'recipient',
  RefUid = 'refUID',
  Revocable = 'revocable',
  RevocationTime = 'revocationTime',
  Revoked = 'revoked',
  SchemaId = 'schemaId',
  Time = 'time',
  TimeCreated = 'timeCreated',
  Txid = 'txid'
}

export type AttestationScalarWhereInput = {
  AND?: Maybe<Array<AttestationScalarWhereInput>>;
  NOT?: Maybe<Array<AttestationScalarWhereInput>>;
  OR?: Maybe<Array<AttestationScalarWhereInput>>;
  attester?: Maybe<StringFilter>;
  data?: Maybe<StringFilter>;
  decodedDataJson?: Maybe<StringFilter>;
  expirationTime?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  ipfsHash?: Maybe<StringFilter>;
  isOffchain?: Maybe<BoolFilter>;
  recipient?: Maybe<StringFilter>;
  refUID?: Maybe<StringFilter>;
  revocable?: Maybe<BoolFilter>;
  revocationTime?: Maybe<IntFilter>;
  revoked?: Maybe<BoolFilter>;
  schemaId?: Maybe<StringFilter>;
  time?: Maybe<IntFilter>;
  timeCreated?: Maybe<IntFilter>;
  txid?: Maybe<StringFilter>;
};

export type AttestationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AttestationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AttestationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AttestationScalarWhereWithAggregatesInput>>;
  attester?: Maybe<StringWithAggregatesFilter>;
  data?: Maybe<StringWithAggregatesFilter>;
  decodedDataJson?: Maybe<StringWithAggregatesFilter>;
  expirationTime?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  ipfsHash?: Maybe<StringWithAggregatesFilter>;
  isOffchain?: Maybe<BoolWithAggregatesFilter>;
  recipient?: Maybe<StringWithAggregatesFilter>;
  refUID?: Maybe<StringWithAggregatesFilter>;
  revocable?: Maybe<BoolWithAggregatesFilter>;
  revocationTime?: Maybe<IntWithAggregatesFilter>;
  revoked?: Maybe<BoolWithAggregatesFilter>;
  schemaId?: Maybe<StringWithAggregatesFilter>;
  time?: Maybe<IntWithAggregatesFilter>;
  timeCreated?: Maybe<IntWithAggregatesFilter>;
  txid?: Maybe<StringWithAggregatesFilter>;
};

export type AttestationSumAggregate = {
  __typename?: 'AttestationSumAggregate';
  expirationTime?: Maybe<Scalars['Int']>;
  revocationTime?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['Int']>;
  timeCreated?: Maybe<Scalars['Int']>;
};

export type AttestationSumOrderByAggregateInput = {
  expirationTime?: Maybe<SortOrder>;
  revocationTime?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  timeCreated?: Maybe<SortOrder>;
};

export type AttestationUpdateInput = {
  attester?: Maybe<StringFieldUpdateOperationsInput>;
  data?: Maybe<StringFieldUpdateOperationsInput>;
  decodedDataJson?: Maybe<StringFieldUpdateOperationsInput>;
  expirationTime?: Maybe<IntFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  ipfsHash?: Maybe<StringFieldUpdateOperationsInput>;
  isOffchain?: Maybe<BoolFieldUpdateOperationsInput>;
  recipient?: Maybe<StringFieldUpdateOperationsInput>;
  refUID?: Maybe<StringFieldUpdateOperationsInput>;
  revocable?: Maybe<BoolFieldUpdateOperationsInput>;
  revocationTime?: Maybe<IntFieldUpdateOperationsInput>;
  revoked?: Maybe<BoolFieldUpdateOperationsInput>;
  schema?: Maybe<SchemaUpdateOneRequiredWithoutAttestationsNestedInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
  timeCreated?: Maybe<IntFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type AttestationUpdateManyMutationInput = {
  attester?: Maybe<StringFieldUpdateOperationsInput>;
  data?: Maybe<StringFieldUpdateOperationsInput>;
  decodedDataJson?: Maybe<StringFieldUpdateOperationsInput>;
  expirationTime?: Maybe<IntFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  ipfsHash?: Maybe<StringFieldUpdateOperationsInput>;
  isOffchain?: Maybe<BoolFieldUpdateOperationsInput>;
  recipient?: Maybe<StringFieldUpdateOperationsInput>;
  refUID?: Maybe<StringFieldUpdateOperationsInput>;
  revocable?: Maybe<BoolFieldUpdateOperationsInput>;
  revocationTime?: Maybe<IntFieldUpdateOperationsInput>;
  revoked?: Maybe<BoolFieldUpdateOperationsInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
  timeCreated?: Maybe<IntFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type AttestationUpdateManyWithWhereWithoutSchemaInput = {
  data: AttestationUpdateManyMutationInput;
  where: AttestationScalarWhereInput;
};

export type AttestationUpdateManyWithoutSchemaNestedInput = {
  connect?: Maybe<Array<AttestationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<AttestationCreateOrConnectWithoutSchemaInput>>;
  create?: Maybe<Array<AttestationCreateWithoutSchemaInput>>;
  createMany?: Maybe<AttestationCreateManySchemaInputEnvelope>;
  delete?: Maybe<Array<AttestationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<AttestationScalarWhereInput>>;
  disconnect?: Maybe<Array<AttestationWhereUniqueInput>>;
  set?: Maybe<Array<AttestationWhereUniqueInput>>;
  update?: Maybe<Array<AttestationUpdateWithWhereUniqueWithoutSchemaInput>>;
  updateMany?: Maybe<Array<AttestationUpdateManyWithWhereWithoutSchemaInput>>;
  upsert?: Maybe<Array<AttestationUpsertWithWhereUniqueWithoutSchemaInput>>;
};

export type AttestationUpdateWithWhereUniqueWithoutSchemaInput = {
  data: AttestationUpdateWithoutSchemaInput;
  where: AttestationWhereUniqueInput;
};

export type AttestationUpdateWithoutSchemaInput = {
  attester?: Maybe<StringFieldUpdateOperationsInput>;
  data?: Maybe<StringFieldUpdateOperationsInput>;
  decodedDataJson?: Maybe<StringFieldUpdateOperationsInput>;
  expirationTime?: Maybe<IntFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  ipfsHash?: Maybe<StringFieldUpdateOperationsInput>;
  isOffchain?: Maybe<BoolFieldUpdateOperationsInput>;
  recipient?: Maybe<StringFieldUpdateOperationsInput>;
  refUID?: Maybe<StringFieldUpdateOperationsInput>;
  revocable?: Maybe<BoolFieldUpdateOperationsInput>;
  revocationTime?: Maybe<IntFieldUpdateOperationsInput>;
  revoked?: Maybe<BoolFieldUpdateOperationsInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
  timeCreated?: Maybe<IntFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type AttestationUpsertWithWhereUniqueWithoutSchemaInput = {
  create: AttestationCreateWithoutSchemaInput;
  update: AttestationUpdateWithoutSchemaInput;
  where: AttestationWhereUniqueInput;
};

export type AttestationWhereInput = {
  AND?: Maybe<Array<AttestationWhereInput>>;
  NOT?: Maybe<Array<AttestationWhereInput>>;
  OR?: Maybe<Array<AttestationWhereInput>>;
  attester?: Maybe<StringFilter>;
  data?: Maybe<StringFilter>;
  decodedDataJson?: Maybe<StringFilter>;
  expirationTime?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  ipfsHash?: Maybe<StringFilter>;
  isOffchain?: Maybe<BoolFilter>;
  recipient?: Maybe<StringFilter>;
  refUID?: Maybe<StringFilter>;
  revocable?: Maybe<BoolFilter>;
  revocationTime?: Maybe<IntFilter>;
  revoked?: Maybe<BoolFilter>;
  schema?: Maybe<SchemaRelationFilter>;
  schemaId?: Maybe<StringFilter>;
  time?: Maybe<IntFilter>;
  timeCreated?: Maybe<IntFilter>;
  txid?: Maybe<StringFilter>;
};

export type AttestationWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedBoolFilter>;
  _min?: Maybe<NestedBoolFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
};

export type EnsName = {
  __typename?: 'EnsName';
  id: Scalars['String'];
  name: Scalars['String'];
  timestamp: Scalars['Int'];
};

export type EnsNameAvgAggregate = {
  __typename?: 'EnsNameAvgAggregate';
  timestamp?: Maybe<Scalars['Float']>;
};

export type EnsNameAvgOrderByAggregateInput = {
  timestamp?: Maybe<SortOrder>;
};

export type EnsNameCountAggregate = {
  __typename?: 'EnsNameCountAggregate';
  _all: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  timestamp: Scalars['Int'];
};

export type EnsNameCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
};

export type EnsNameCreateInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  timestamp: Scalars['Int'];
};

export type EnsNameCreateManyInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  timestamp: Scalars['Int'];
};

export type EnsNameGroupBy = {
  __typename?: 'EnsNameGroupBy';
  _avg?: Maybe<EnsNameAvgAggregate>;
  _count?: Maybe<EnsNameCountAggregate>;
  _max?: Maybe<EnsNameMaxAggregate>;
  _min?: Maybe<EnsNameMinAggregate>;
  _sum?: Maybe<EnsNameSumAggregate>;
  id: Scalars['String'];
  name: Scalars['String'];
  timestamp: Scalars['Int'];
};

export type EnsNameMaxAggregate = {
  __typename?: 'EnsNameMaxAggregate';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Int']>;
};

export type EnsNameMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
};

export type EnsNameMinAggregate = {
  __typename?: 'EnsNameMinAggregate';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Int']>;
};

export type EnsNameMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
};

export type EnsNameOrderByWithAggregationInput = {
  _avg?: Maybe<EnsNameAvgOrderByAggregateInput>;
  _count?: Maybe<EnsNameCountOrderByAggregateInput>;
  _max?: Maybe<EnsNameMaxOrderByAggregateInput>;
  _min?: Maybe<EnsNameMinOrderByAggregateInput>;
  _sum?: Maybe<EnsNameSumOrderByAggregateInput>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
};

export type EnsNameOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
};

export enum EnsNameScalarFieldEnum {
  Id = 'id',
  Name = 'name',
  Timestamp = 'timestamp'
}

export type EnsNameScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EnsNameScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EnsNameScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EnsNameScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  timestamp?: Maybe<IntWithAggregatesFilter>;
};

export type EnsNameSumAggregate = {
  __typename?: 'EnsNameSumAggregate';
  timestamp?: Maybe<Scalars['Int']>;
};

export type EnsNameSumOrderByAggregateInput = {
  timestamp?: Maybe<SortOrder>;
};

export type EnsNameUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  timestamp?: Maybe<IntFieldUpdateOperationsInput>;
};

export type EnsNameUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  timestamp?: Maybe<IntFieldUpdateOperationsInput>;
};

export type EnsNameWhereInput = {
  AND?: Maybe<Array<EnsNameWhereInput>>;
  NOT?: Maybe<Array<EnsNameWhereInput>>;
  OR?: Maybe<Array<EnsNameWhereInput>>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  timestamp?: Maybe<IntFilter>;
};

export type EnsNameWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Int']>;
  divide?: Maybe<Scalars['Int']>;
  increment?: Maybe<Scalars['Int']>;
  multiply?: Maybe<Scalars['Int']>;
  set?: Maybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _sum?: Maybe<NestedIntFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createManyAttestation: AffectedRowsOutput;
  createManyEnsName: AffectedRowsOutput;
  createManyOffchainRevocation: AffectedRowsOutput;
  createManySchema: AffectedRowsOutput;
  createManySchemaName: AffectedRowsOutput;
  createManyServiceStat: AffectedRowsOutput;
  createManyTimestamp: AffectedRowsOutput;
  createOneAttestation: Attestation;
  createOneEnsName: EnsName;
  createOneOffchainRevocation: OffchainRevocation;
  createOneSchema: Schema;
  createOneSchemaName: SchemaName;
  createOneServiceStat: ServiceStat;
  createOneTimestamp: Timestamp;
  deleteManyAttestation: AffectedRowsOutput;
  deleteManyEnsName: AffectedRowsOutput;
  deleteManyOffchainRevocation: AffectedRowsOutput;
  deleteManySchema: AffectedRowsOutput;
  deleteManySchemaName: AffectedRowsOutput;
  deleteManyServiceStat: AffectedRowsOutput;
  deleteManyTimestamp: AffectedRowsOutput;
  deleteOneAttestation?: Maybe<Attestation>;
  deleteOneEnsName?: Maybe<EnsName>;
  deleteOneOffchainRevocation?: Maybe<OffchainRevocation>;
  deleteOneSchema?: Maybe<Schema>;
  deleteOneSchemaName?: Maybe<SchemaName>;
  deleteOneServiceStat?: Maybe<ServiceStat>;
  deleteOneTimestamp?: Maybe<Timestamp>;
  updateManyAttestation: AffectedRowsOutput;
  updateManyEnsName: AffectedRowsOutput;
  updateManyOffchainRevocation: AffectedRowsOutput;
  updateManySchema: AffectedRowsOutput;
  updateManySchemaName: AffectedRowsOutput;
  updateManyServiceStat: AffectedRowsOutput;
  updateManyTimestamp: AffectedRowsOutput;
  updateOneAttestation?: Maybe<Attestation>;
  updateOneEnsName?: Maybe<EnsName>;
  updateOneOffchainRevocation?: Maybe<OffchainRevocation>;
  updateOneSchema?: Maybe<Schema>;
  updateOneSchemaName?: Maybe<SchemaName>;
  updateOneServiceStat?: Maybe<ServiceStat>;
  updateOneTimestamp?: Maybe<Timestamp>;
  upsertOneAttestation: Attestation;
  upsertOneEnsName: EnsName;
  upsertOneOffchainRevocation: OffchainRevocation;
  upsertOneSchema: Schema;
  upsertOneSchemaName: SchemaName;
  upsertOneServiceStat: ServiceStat;
  upsertOneTimestamp: Timestamp;
};


export type MutationCreateManyAttestationArgs = {
  data: Array<AttestationCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyEnsNameArgs = {
  data: Array<EnsNameCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyOffchainRevocationArgs = {
  data: Array<OffchainRevocationCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManySchemaArgs = {
  data: Array<SchemaCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManySchemaNameArgs = {
  data: Array<SchemaNameCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyServiceStatArgs = {
  data: Array<ServiceStatCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyTimestampArgs = {
  data: Array<TimestampCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateOneAttestationArgs = {
  data: AttestationCreateInput;
};


export type MutationCreateOneEnsNameArgs = {
  data: EnsNameCreateInput;
};


export type MutationCreateOneOffchainRevocationArgs = {
  data: OffchainRevocationCreateInput;
};


export type MutationCreateOneSchemaArgs = {
  data: SchemaCreateInput;
};


export type MutationCreateOneSchemaNameArgs = {
  data: SchemaNameCreateInput;
};


export type MutationCreateOneServiceStatArgs = {
  data: ServiceStatCreateInput;
};


export type MutationCreateOneTimestampArgs = {
  data: TimestampCreateInput;
};


export type MutationDeleteManyAttestationArgs = {
  where?: Maybe<AttestationWhereInput>;
};


export type MutationDeleteManyEnsNameArgs = {
  where?: Maybe<EnsNameWhereInput>;
};


export type MutationDeleteManyOffchainRevocationArgs = {
  where?: Maybe<OffchainRevocationWhereInput>;
};


export type MutationDeleteManySchemaArgs = {
  where?: Maybe<SchemaWhereInput>;
};


export type MutationDeleteManySchemaNameArgs = {
  where?: Maybe<SchemaNameWhereInput>;
};


export type MutationDeleteManyServiceStatArgs = {
  where?: Maybe<ServiceStatWhereInput>;
};


export type MutationDeleteManyTimestampArgs = {
  where?: Maybe<TimestampWhereInput>;
};


export type MutationDeleteOneAttestationArgs = {
  where: AttestationWhereUniqueInput;
};


export type MutationDeleteOneEnsNameArgs = {
  where: EnsNameWhereUniqueInput;
};


export type MutationDeleteOneOffchainRevocationArgs = {
  where: OffchainRevocationWhereUniqueInput;
};


export type MutationDeleteOneSchemaArgs = {
  where: SchemaWhereUniqueInput;
};


export type MutationDeleteOneSchemaNameArgs = {
  where: SchemaNameWhereUniqueInput;
};


export type MutationDeleteOneServiceStatArgs = {
  where: ServiceStatWhereUniqueInput;
};


export type MutationDeleteOneTimestampArgs = {
  where: TimestampWhereUniqueInput;
};


export type MutationUpdateManyAttestationArgs = {
  data: AttestationUpdateManyMutationInput;
  where?: Maybe<AttestationWhereInput>;
};


export type MutationUpdateManyEnsNameArgs = {
  data: EnsNameUpdateManyMutationInput;
  where?: Maybe<EnsNameWhereInput>;
};


export type MutationUpdateManyOffchainRevocationArgs = {
  data: OffchainRevocationUpdateManyMutationInput;
  where?: Maybe<OffchainRevocationWhereInput>;
};


export type MutationUpdateManySchemaArgs = {
  data: SchemaUpdateManyMutationInput;
  where?: Maybe<SchemaWhereInput>;
};


export type MutationUpdateManySchemaNameArgs = {
  data: SchemaNameUpdateManyMutationInput;
  where?: Maybe<SchemaNameWhereInput>;
};


export type MutationUpdateManyServiceStatArgs = {
  data: ServiceStatUpdateManyMutationInput;
  where?: Maybe<ServiceStatWhereInput>;
};


export type MutationUpdateManyTimestampArgs = {
  data: TimestampUpdateManyMutationInput;
  where?: Maybe<TimestampWhereInput>;
};


export type MutationUpdateOneAttestationArgs = {
  data: AttestationUpdateInput;
  where: AttestationWhereUniqueInput;
};


export type MutationUpdateOneEnsNameArgs = {
  data: EnsNameUpdateInput;
  where: EnsNameWhereUniqueInput;
};


export type MutationUpdateOneOffchainRevocationArgs = {
  data: OffchainRevocationUpdateInput;
  where: OffchainRevocationWhereUniqueInput;
};


export type MutationUpdateOneSchemaArgs = {
  data: SchemaUpdateInput;
  where: SchemaWhereUniqueInput;
};


export type MutationUpdateOneSchemaNameArgs = {
  data: SchemaNameUpdateInput;
  where: SchemaNameWhereUniqueInput;
};


export type MutationUpdateOneServiceStatArgs = {
  data: ServiceStatUpdateInput;
  where: ServiceStatWhereUniqueInput;
};


export type MutationUpdateOneTimestampArgs = {
  data: TimestampUpdateInput;
  where: TimestampWhereUniqueInput;
};


export type MutationUpsertOneAttestationArgs = {
  create: AttestationCreateInput;
  update: AttestationUpdateInput;
  where: AttestationWhereUniqueInput;
};


export type MutationUpsertOneEnsNameArgs = {
  create: EnsNameCreateInput;
  update: EnsNameUpdateInput;
  where: EnsNameWhereUniqueInput;
};


export type MutationUpsertOneOffchainRevocationArgs = {
  create: OffchainRevocationCreateInput;
  update: OffchainRevocationUpdateInput;
  where: OffchainRevocationWhereUniqueInput;
};


export type MutationUpsertOneSchemaArgs = {
  create: SchemaCreateInput;
  update: SchemaUpdateInput;
  where: SchemaWhereUniqueInput;
};


export type MutationUpsertOneSchemaNameArgs = {
  create: SchemaNameCreateInput;
  update: SchemaNameUpdateInput;
  where: SchemaNameWhereUniqueInput;
};


export type MutationUpsertOneServiceStatArgs = {
  create: ServiceStatCreateInput;
  update: ServiceStatUpdateInput;
  where: ServiceStatWhereUniqueInput;
};


export type MutationUpsertOneTimestampArgs = {
  create: TimestampCreateInput;
  update: TimestampUpdateInput;
  where: TimestampWhereUniqueInput;
};

export type NestedBoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedBoolFilter>;
  _min?: Maybe<NestedBoolFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
};

export type NestedFloatFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _sum?: Maybe<NestedIntFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedStringFilter>;
  _min?: Maybe<NestedStringFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type OffchainRevocation = {
  __typename?: 'OffchainRevocation';
  from: Scalars['String'];
  id: Scalars['String'];
  timestamp: Scalars['Int'];
  txid: Scalars['String'];
  uid: Scalars['String'];
};

export type OffchainRevocationAvgAggregate = {
  __typename?: 'OffchainRevocationAvgAggregate';
  timestamp?: Maybe<Scalars['Float']>;
};

export type OffchainRevocationAvgOrderByAggregateInput = {
  timestamp?: Maybe<SortOrder>;
};

export type OffchainRevocationCountAggregate = {
  __typename?: 'OffchainRevocationCountAggregate';
  _all: Scalars['Int'];
  from: Scalars['Int'];
  id: Scalars['Int'];
  timestamp: Scalars['Int'];
  txid: Scalars['Int'];
  uid: Scalars['Int'];
};

export type OffchainRevocationCountOrderByAggregateInput = {
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
  uid?: Maybe<SortOrder>;
};

export type OffchainRevocationCreateInput = {
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  timestamp: Scalars['Int'];
  txid: Scalars['String'];
  uid: Scalars['String'];
};

export type OffchainRevocationCreateManyInput = {
  from: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  timestamp: Scalars['Int'];
  txid: Scalars['String'];
  uid: Scalars['String'];
};

export type OffchainRevocationGroupBy = {
  __typename?: 'OffchainRevocationGroupBy';
  _avg?: Maybe<OffchainRevocationAvgAggregate>;
  _count?: Maybe<OffchainRevocationCountAggregate>;
  _max?: Maybe<OffchainRevocationMaxAggregate>;
  _min?: Maybe<OffchainRevocationMinAggregate>;
  _sum?: Maybe<OffchainRevocationSumAggregate>;
  from: Scalars['String'];
  id: Scalars['String'];
  timestamp: Scalars['Int'];
  txid: Scalars['String'];
  uid: Scalars['String'];
};

export type OffchainRevocationMaxAggregate = {
  __typename?: 'OffchainRevocationMaxAggregate';
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Int']>;
  txid?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type OffchainRevocationMaxOrderByAggregateInput = {
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
  uid?: Maybe<SortOrder>;
};

export type OffchainRevocationMinAggregate = {
  __typename?: 'OffchainRevocationMinAggregate';
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Int']>;
  txid?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type OffchainRevocationMinOrderByAggregateInput = {
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
  uid?: Maybe<SortOrder>;
};

export type OffchainRevocationOrderByWithAggregationInput = {
  _avg?: Maybe<OffchainRevocationAvgOrderByAggregateInput>;
  _count?: Maybe<OffchainRevocationCountOrderByAggregateInput>;
  _max?: Maybe<OffchainRevocationMaxOrderByAggregateInput>;
  _min?: Maybe<OffchainRevocationMinOrderByAggregateInput>;
  _sum?: Maybe<OffchainRevocationSumOrderByAggregateInput>;
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
  uid?: Maybe<SortOrder>;
};

export type OffchainRevocationOrderByWithRelationInput = {
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
  uid?: Maybe<SortOrder>;
};

export enum OffchainRevocationScalarFieldEnum {
  From = 'from',
  Id = 'id',
  Timestamp = 'timestamp',
  Txid = 'txid',
  Uid = 'uid'
}

export type OffchainRevocationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OffchainRevocationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OffchainRevocationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OffchainRevocationScalarWhereWithAggregatesInput>>;
  from?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  timestamp?: Maybe<IntWithAggregatesFilter>;
  txid?: Maybe<StringWithAggregatesFilter>;
  uid?: Maybe<StringWithAggregatesFilter>;
};

export type OffchainRevocationSumAggregate = {
  __typename?: 'OffchainRevocationSumAggregate';
  timestamp?: Maybe<Scalars['Int']>;
};

export type OffchainRevocationSumOrderByAggregateInput = {
  timestamp?: Maybe<SortOrder>;
};

export type OffchainRevocationUpdateInput = {
  from?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  timestamp?: Maybe<IntFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
  uid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type OffchainRevocationUpdateManyMutationInput = {
  from?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  timestamp?: Maybe<IntFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
  uid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type OffchainRevocationWhereInput = {
  AND?: Maybe<Array<OffchainRevocationWhereInput>>;
  NOT?: Maybe<Array<OffchainRevocationWhereInput>>;
  OR?: Maybe<Array<OffchainRevocationWhereInput>>;
  from?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  timestamp?: Maybe<IntFilter>;
  txid?: Maybe<StringFilter>;
  uid?: Maybe<StringFilter>;
};

export type OffchainRevocationWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  aggregateAttestation: AggregateAttestation;
  aggregateEnsName: AggregateEnsName;
  aggregateOffchainRevocation: AggregateOffchainRevocation;
  aggregateSchema: AggregateSchema;
  aggregateSchemaName: AggregateSchemaName;
  aggregateServiceStat: AggregateServiceStat;
  aggregateTimestamp: AggregateTimestamp;
  attestation?: Maybe<Attestation>;
  attestations: Array<Attestation>;
  ensName?: Maybe<EnsName>;
  ensNames: Array<EnsName>;
  findFirstAttestation?: Maybe<Attestation>;
  findFirstAttestationOrThrow?: Maybe<Attestation>;
  findFirstEnsName?: Maybe<EnsName>;
  findFirstEnsNameOrThrow?: Maybe<EnsName>;
  findFirstOffchainRevocation?: Maybe<OffchainRevocation>;
  findFirstOffchainRevocationOrThrow?: Maybe<OffchainRevocation>;
  findFirstSchema?: Maybe<Schema>;
  findFirstSchemaName?: Maybe<SchemaName>;
  findFirstSchemaNameOrThrow?: Maybe<SchemaName>;
  findFirstSchemaOrThrow?: Maybe<Schema>;
  findFirstServiceStat?: Maybe<ServiceStat>;
  findFirstServiceStatOrThrow?: Maybe<ServiceStat>;
  findFirstTimestamp?: Maybe<Timestamp>;
  findFirstTimestampOrThrow?: Maybe<Timestamp>;
  getAttestation?: Maybe<Attestation>;
  getEnsName?: Maybe<EnsName>;
  getOffchainRevocation?: Maybe<OffchainRevocation>;
  getSchema?: Maybe<Schema>;
  getSchemaName?: Maybe<SchemaName>;
  getServiceStat?: Maybe<ServiceStat>;
  getTimestamp?: Maybe<Timestamp>;
  groupByAttestation: Array<AttestationGroupBy>;
  groupByEnsName: Array<EnsNameGroupBy>;
  groupByOffchainRevocation: Array<OffchainRevocationGroupBy>;
  groupBySchema: Array<SchemaGroupBy>;
  groupBySchemaName: Array<SchemaNameGroupBy>;
  groupByServiceStat: Array<ServiceStatGroupBy>;
  groupByTimestamp: Array<TimestampGroupBy>;
  offchainRevocation?: Maybe<OffchainRevocation>;
  offchainRevocations: Array<OffchainRevocation>;
  schema?: Maybe<Schema>;
  schemaName?: Maybe<SchemaName>;
  schemaNames: Array<SchemaName>;
  schemata: Array<Schema>;
  serviceStat?: Maybe<ServiceStat>;
  serviceStats: Array<ServiceStat>;
  timestamp?: Maybe<Timestamp>;
  timestamps: Array<Timestamp>;
};


export type QueryAggregateAttestationArgs = {
  cursor?: Maybe<AttestationWhereUniqueInput>;
  orderBy?: Maybe<Array<AttestationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AttestationWhereInput>;
};


export type QueryAggregateEnsNameArgs = {
  cursor?: Maybe<EnsNameWhereUniqueInput>;
  orderBy?: Maybe<Array<EnsNameOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnsNameWhereInput>;
};


export type QueryAggregateOffchainRevocationArgs = {
  cursor?: Maybe<OffchainRevocationWhereUniqueInput>;
  orderBy?: Maybe<Array<OffchainRevocationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OffchainRevocationWhereInput>;
};


export type QueryAggregateSchemaArgs = {
  cursor?: Maybe<SchemaWhereUniqueInput>;
  orderBy?: Maybe<Array<SchemaOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaWhereInput>;
};


export type QueryAggregateSchemaNameArgs = {
  cursor?: Maybe<SchemaNameWhereUniqueInput>;
  orderBy?: Maybe<Array<SchemaNameOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaNameWhereInput>;
};


export type QueryAggregateServiceStatArgs = {
  cursor?: Maybe<ServiceStatWhereUniqueInput>;
  orderBy?: Maybe<Array<ServiceStatOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceStatWhereInput>;
};


export type QueryAggregateTimestampArgs = {
  cursor?: Maybe<TimestampWhereUniqueInput>;
  orderBy?: Maybe<Array<TimestampOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TimestampWhereInput>;
};


export type QueryAttestationArgs = {
  where: AttestationWhereUniqueInput;
};


export type QueryAttestationsArgs = {
  cursor?: Maybe<AttestationWhereUniqueInput>;
  distinct?: Maybe<Array<AttestationScalarFieldEnum>>;
  orderBy?: Maybe<Array<AttestationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AttestationWhereInput>;
};


export type QueryEnsNameArgs = {
  where: EnsNameWhereUniqueInput;
};


export type QueryEnsNamesArgs = {
  cursor?: Maybe<EnsNameWhereUniqueInput>;
  distinct?: Maybe<Array<EnsNameScalarFieldEnum>>;
  orderBy?: Maybe<Array<EnsNameOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnsNameWhereInput>;
};


export type QueryFindFirstAttestationArgs = {
  cursor?: Maybe<AttestationWhereUniqueInput>;
  distinct?: Maybe<Array<AttestationScalarFieldEnum>>;
  orderBy?: Maybe<Array<AttestationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AttestationWhereInput>;
};


export type QueryFindFirstAttestationOrThrowArgs = {
  cursor?: Maybe<AttestationWhereUniqueInput>;
  distinct?: Maybe<Array<AttestationScalarFieldEnum>>;
  orderBy?: Maybe<Array<AttestationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AttestationWhereInput>;
};


export type QueryFindFirstEnsNameArgs = {
  cursor?: Maybe<EnsNameWhereUniqueInput>;
  distinct?: Maybe<Array<EnsNameScalarFieldEnum>>;
  orderBy?: Maybe<Array<EnsNameOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnsNameWhereInput>;
};


export type QueryFindFirstEnsNameOrThrowArgs = {
  cursor?: Maybe<EnsNameWhereUniqueInput>;
  distinct?: Maybe<Array<EnsNameScalarFieldEnum>>;
  orderBy?: Maybe<Array<EnsNameOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnsNameWhereInput>;
};


export type QueryFindFirstOffchainRevocationArgs = {
  cursor?: Maybe<OffchainRevocationWhereUniqueInput>;
  distinct?: Maybe<Array<OffchainRevocationScalarFieldEnum>>;
  orderBy?: Maybe<Array<OffchainRevocationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OffchainRevocationWhereInput>;
};


export type QueryFindFirstOffchainRevocationOrThrowArgs = {
  cursor?: Maybe<OffchainRevocationWhereUniqueInput>;
  distinct?: Maybe<Array<OffchainRevocationScalarFieldEnum>>;
  orderBy?: Maybe<Array<OffchainRevocationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OffchainRevocationWhereInput>;
};


export type QueryFindFirstSchemaArgs = {
  cursor?: Maybe<SchemaWhereUniqueInput>;
  distinct?: Maybe<Array<SchemaScalarFieldEnum>>;
  orderBy?: Maybe<Array<SchemaOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaWhereInput>;
};


export type QueryFindFirstSchemaNameArgs = {
  cursor?: Maybe<SchemaNameWhereUniqueInput>;
  distinct?: Maybe<Array<SchemaNameScalarFieldEnum>>;
  orderBy?: Maybe<Array<SchemaNameOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaNameWhereInput>;
};


export type QueryFindFirstSchemaNameOrThrowArgs = {
  cursor?: Maybe<SchemaNameWhereUniqueInput>;
  distinct?: Maybe<Array<SchemaNameScalarFieldEnum>>;
  orderBy?: Maybe<Array<SchemaNameOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaNameWhereInput>;
};


export type QueryFindFirstSchemaOrThrowArgs = {
  cursor?: Maybe<SchemaWhereUniqueInput>;
  distinct?: Maybe<Array<SchemaScalarFieldEnum>>;
  orderBy?: Maybe<Array<SchemaOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaWhereInput>;
};


export type QueryFindFirstServiceStatArgs = {
  cursor?: Maybe<ServiceStatWhereUniqueInput>;
  distinct?: Maybe<Array<ServiceStatScalarFieldEnum>>;
  orderBy?: Maybe<Array<ServiceStatOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceStatWhereInput>;
};


export type QueryFindFirstServiceStatOrThrowArgs = {
  cursor?: Maybe<ServiceStatWhereUniqueInput>;
  distinct?: Maybe<Array<ServiceStatScalarFieldEnum>>;
  orderBy?: Maybe<Array<ServiceStatOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceStatWhereInput>;
};


export type QueryFindFirstTimestampArgs = {
  cursor?: Maybe<TimestampWhereUniqueInput>;
  distinct?: Maybe<Array<TimestampScalarFieldEnum>>;
  orderBy?: Maybe<Array<TimestampOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TimestampWhereInput>;
};


export type QueryFindFirstTimestampOrThrowArgs = {
  cursor?: Maybe<TimestampWhereUniqueInput>;
  distinct?: Maybe<Array<TimestampScalarFieldEnum>>;
  orderBy?: Maybe<Array<TimestampOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TimestampWhereInput>;
};


export type QueryGetAttestationArgs = {
  where: AttestationWhereUniqueInput;
};


export type QueryGetEnsNameArgs = {
  where: EnsNameWhereUniqueInput;
};


export type QueryGetOffchainRevocationArgs = {
  where: OffchainRevocationWhereUniqueInput;
};


export type QueryGetSchemaArgs = {
  where: SchemaWhereUniqueInput;
};


export type QueryGetSchemaNameArgs = {
  where: SchemaNameWhereUniqueInput;
};


export type QueryGetServiceStatArgs = {
  where: ServiceStatWhereUniqueInput;
};


export type QueryGetTimestampArgs = {
  where: TimestampWhereUniqueInput;
};


export type QueryGroupByAttestationArgs = {
  by: Array<AttestationScalarFieldEnum>;
  having?: Maybe<AttestationScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<AttestationOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AttestationWhereInput>;
};


export type QueryGroupByEnsNameArgs = {
  by: Array<EnsNameScalarFieldEnum>;
  having?: Maybe<EnsNameScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<EnsNameOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnsNameWhereInput>;
};


export type QueryGroupByOffchainRevocationArgs = {
  by: Array<OffchainRevocationScalarFieldEnum>;
  having?: Maybe<OffchainRevocationScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<OffchainRevocationOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OffchainRevocationWhereInput>;
};


export type QueryGroupBySchemaArgs = {
  by: Array<SchemaScalarFieldEnum>;
  having?: Maybe<SchemaScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<SchemaOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaWhereInput>;
};


export type QueryGroupBySchemaNameArgs = {
  by: Array<SchemaNameScalarFieldEnum>;
  having?: Maybe<SchemaNameScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<SchemaNameOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaNameWhereInput>;
};


export type QueryGroupByServiceStatArgs = {
  by: Array<ServiceStatScalarFieldEnum>;
  having?: Maybe<ServiceStatScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<ServiceStatOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceStatWhereInput>;
};


export type QueryGroupByTimestampArgs = {
  by: Array<TimestampScalarFieldEnum>;
  having?: Maybe<TimestampScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<TimestampOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TimestampWhereInput>;
};


export type QueryOffchainRevocationArgs = {
  where: OffchainRevocationWhereUniqueInput;
};


export type QueryOffchainRevocationsArgs = {
  cursor?: Maybe<OffchainRevocationWhereUniqueInput>;
  distinct?: Maybe<Array<OffchainRevocationScalarFieldEnum>>;
  orderBy?: Maybe<Array<OffchainRevocationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<OffchainRevocationWhereInput>;
};


export type QuerySchemaArgs = {
  where: SchemaWhereUniqueInput;
};


export type QuerySchemaNameArgs = {
  where: SchemaNameWhereUniqueInput;
};


export type QuerySchemaNamesArgs = {
  cursor?: Maybe<SchemaNameWhereUniqueInput>;
  distinct?: Maybe<Array<SchemaNameScalarFieldEnum>>;
  orderBy?: Maybe<Array<SchemaNameOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaNameWhereInput>;
};


export type QuerySchemataArgs = {
  cursor?: Maybe<SchemaWhereUniqueInput>;
  distinct?: Maybe<Array<SchemaScalarFieldEnum>>;
  orderBy?: Maybe<Array<SchemaOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaWhereInput>;
};


export type QueryServiceStatArgs = {
  where: ServiceStatWhereUniqueInput;
};


export type QueryServiceStatsArgs = {
  cursor?: Maybe<ServiceStatWhereUniqueInput>;
  distinct?: Maybe<Array<ServiceStatScalarFieldEnum>>;
  orderBy?: Maybe<Array<ServiceStatOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ServiceStatWhereInput>;
};


export type QueryTimestampArgs = {
  where: TimestampWhereUniqueInput;
};


export type QueryTimestampsArgs = {
  cursor?: Maybe<TimestampWhereUniqueInput>;
  distinct?: Maybe<Array<TimestampScalarFieldEnum>>;
  orderBy?: Maybe<Array<TimestampOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TimestampWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Schema = {
  __typename?: 'Schema';
  _count?: Maybe<SchemaCount>;
  attestations: Array<Attestation>;
  creator: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['String'];
  resolver: Scalars['String'];
  revocable: Scalars['Boolean'];
  schema: Scalars['String'];
  schemaNames: Array<SchemaName>;
  time: Scalars['Int'];
  txid: Scalars['String'];
};


export type SchemaAttestationsArgs = {
  cursor?: Maybe<AttestationWhereUniqueInput>;
  distinct?: Maybe<Array<AttestationScalarFieldEnum>>;
  orderBy?: Maybe<Array<AttestationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AttestationWhereInput>;
};


export type SchemaSchemaNamesArgs = {
  cursor?: Maybe<SchemaNameWhereUniqueInput>;
  distinct?: Maybe<Array<SchemaNameScalarFieldEnum>>;
  orderBy?: Maybe<Array<SchemaNameOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SchemaNameWhereInput>;
};

export type SchemaAvgAggregate = {
  __typename?: 'SchemaAvgAggregate';
  time?: Maybe<Scalars['Float']>;
};

export type SchemaAvgOrderByAggregateInput = {
  time?: Maybe<SortOrder>;
};

export type SchemaCount = {
  __typename?: 'SchemaCount';
  attestations: Scalars['Int'];
  schemaNames: Scalars['Int'];
};

export type SchemaCountAggregate = {
  __typename?: 'SchemaCountAggregate';
  _all: Scalars['Int'];
  creator: Scalars['Int'];
  id: Scalars['Int'];
  index: Scalars['Int'];
  resolver: Scalars['Int'];
  revocable: Scalars['Int'];
  schema: Scalars['Int'];
  time: Scalars['Int'];
  txid: Scalars['Int'];
};

export type SchemaCountOrderByAggregateInput = {
  creator?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  resolver?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  schema?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type SchemaCreateInput = {
  attestations?: Maybe<AttestationCreateNestedManyWithoutSchemaInput>;
  creator: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['String'];
  resolver: Scalars['String'];
  revocable: Scalars['Boolean'];
  schema: Scalars['String'];
  schemaNames?: Maybe<SchemaNameCreateNestedManyWithoutSchemaInput>;
  time: Scalars['Int'];
  txid: Scalars['String'];
};

export type SchemaCreateManyInput = {
  creator: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['String'];
  resolver: Scalars['String'];
  revocable: Scalars['Boolean'];
  schema: Scalars['String'];
  time: Scalars['Int'];
  txid: Scalars['String'];
};

export type SchemaCreateNestedOneWithoutAttestationsInput = {
  connect?: Maybe<SchemaWhereUniqueInput>;
  connectOrCreate?: Maybe<SchemaCreateOrConnectWithoutAttestationsInput>;
  create?: Maybe<SchemaCreateWithoutAttestationsInput>;
};

export type SchemaCreateNestedOneWithoutSchemaNamesInput = {
  connect?: Maybe<SchemaWhereUniqueInput>;
  connectOrCreate?: Maybe<SchemaCreateOrConnectWithoutSchemaNamesInput>;
  create?: Maybe<SchemaCreateWithoutSchemaNamesInput>;
};

export type SchemaCreateOrConnectWithoutAttestationsInput = {
  create: SchemaCreateWithoutAttestationsInput;
  where: SchemaWhereUniqueInput;
};

export type SchemaCreateOrConnectWithoutSchemaNamesInput = {
  create: SchemaCreateWithoutSchemaNamesInput;
  where: SchemaWhereUniqueInput;
};

export type SchemaCreateWithoutAttestationsInput = {
  creator: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['String'];
  resolver: Scalars['String'];
  revocable: Scalars['Boolean'];
  schema: Scalars['String'];
  schemaNames?: Maybe<SchemaNameCreateNestedManyWithoutSchemaInput>;
  time: Scalars['Int'];
  txid: Scalars['String'];
};

export type SchemaCreateWithoutSchemaNamesInput = {
  attestations?: Maybe<AttestationCreateNestedManyWithoutSchemaInput>;
  creator: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['String'];
  resolver: Scalars['String'];
  revocable: Scalars['Boolean'];
  schema: Scalars['String'];
  time: Scalars['Int'];
  txid: Scalars['String'];
};

export type SchemaGroupBy = {
  __typename?: 'SchemaGroupBy';
  _avg?: Maybe<SchemaAvgAggregate>;
  _count?: Maybe<SchemaCountAggregate>;
  _max?: Maybe<SchemaMaxAggregate>;
  _min?: Maybe<SchemaMinAggregate>;
  _sum?: Maybe<SchemaSumAggregate>;
  creator: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['String'];
  resolver: Scalars['String'];
  revocable: Scalars['Boolean'];
  schema: Scalars['String'];
  time: Scalars['Int'];
  txid: Scalars['String'];
};

export type SchemaMaxAggregate = {
  __typename?: 'SchemaMaxAggregate';
  creator?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['String']>;
  resolver?: Maybe<Scalars['String']>;
  revocable?: Maybe<Scalars['Boolean']>;
  schema?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
  txid?: Maybe<Scalars['String']>;
};

export type SchemaMaxOrderByAggregateInput = {
  creator?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  resolver?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  schema?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type SchemaMinAggregate = {
  __typename?: 'SchemaMinAggregate';
  creator?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['String']>;
  resolver?: Maybe<Scalars['String']>;
  revocable?: Maybe<Scalars['Boolean']>;
  schema?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
  txid?: Maybe<Scalars['String']>;
};

export type SchemaMinOrderByAggregateInput = {
  creator?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  resolver?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  schema?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type SchemaName = {
  __typename?: 'SchemaName';
  attesterAddress: Scalars['String'];
  id: Scalars['String'];
  isCreator: Scalars['Boolean'];
  name: Scalars['String'];
  schema: Schema;
  schemaId: Scalars['String'];
  time: Scalars['Int'];
};

export type SchemaNameAvgAggregate = {
  __typename?: 'SchemaNameAvgAggregate';
  time?: Maybe<Scalars['Float']>;
};

export type SchemaNameAvgOrderByAggregateInput = {
  time?: Maybe<SortOrder>;
};

export type SchemaNameCountAggregate = {
  __typename?: 'SchemaNameCountAggregate';
  _all: Scalars['Int'];
  attesterAddress: Scalars['Int'];
  id: Scalars['Int'];
  isCreator: Scalars['Int'];
  name: Scalars['Int'];
  schemaId: Scalars['Int'];
  time: Scalars['Int'];
};

export type SchemaNameCountOrderByAggregateInput = {
  attesterAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCreator?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
};

export type SchemaNameCreateInput = {
  attesterAddress: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCreator: Scalars['Boolean'];
  name: Scalars['String'];
  schema: SchemaCreateNestedOneWithoutSchemaNamesInput;
  time: Scalars['Int'];
};

export type SchemaNameCreateManyInput = {
  attesterAddress: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCreator: Scalars['Boolean'];
  name: Scalars['String'];
  schemaId: Scalars['String'];
  time: Scalars['Int'];
};

export type SchemaNameCreateManySchemaInput = {
  attesterAddress: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCreator: Scalars['Boolean'];
  name: Scalars['String'];
  time: Scalars['Int'];
};

export type SchemaNameCreateManySchemaInputEnvelope = {
  data: Array<SchemaNameCreateManySchemaInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SchemaNameCreateNestedManyWithoutSchemaInput = {
  connect?: Maybe<Array<SchemaNameWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SchemaNameCreateOrConnectWithoutSchemaInput>>;
  create?: Maybe<Array<SchemaNameCreateWithoutSchemaInput>>;
  createMany?: Maybe<SchemaNameCreateManySchemaInputEnvelope>;
};

export type SchemaNameCreateOrConnectWithoutSchemaInput = {
  create: SchemaNameCreateWithoutSchemaInput;
  where: SchemaNameWhereUniqueInput;
};

export type SchemaNameCreateWithoutSchemaInput = {
  attesterAddress: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isCreator: Scalars['Boolean'];
  name: Scalars['String'];
  time: Scalars['Int'];
};

export type SchemaNameGroupBy = {
  __typename?: 'SchemaNameGroupBy';
  _avg?: Maybe<SchemaNameAvgAggregate>;
  _count?: Maybe<SchemaNameCountAggregate>;
  _max?: Maybe<SchemaNameMaxAggregate>;
  _min?: Maybe<SchemaNameMinAggregate>;
  _sum?: Maybe<SchemaNameSumAggregate>;
  attesterAddress: Scalars['String'];
  id: Scalars['String'];
  isCreator: Scalars['Boolean'];
  name: Scalars['String'];
  schemaId: Scalars['String'];
  time: Scalars['Int'];
};

export type SchemaNameListRelationFilter = {
  every?: Maybe<SchemaNameWhereInput>;
  none?: Maybe<SchemaNameWhereInput>;
  some?: Maybe<SchemaNameWhereInput>;
};

export type SchemaNameMaxAggregate = {
  __typename?: 'SchemaNameMaxAggregate';
  attesterAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCreator?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  schemaId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
};

export type SchemaNameMaxOrderByAggregateInput = {
  attesterAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCreator?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
};

export type SchemaNameMinAggregate = {
  __typename?: 'SchemaNameMinAggregate';
  attesterAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCreator?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  schemaId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
};

export type SchemaNameMinOrderByAggregateInput = {
  attesterAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCreator?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
};

export type SchemaNameOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SchemaNameOrderByWithAggregationInput = {
  _avg?: Maybe<SchemaNameAvgOrderByAggregateInput>;
  _count?: Maybe<SchemaNameCountOrderByAggregateInput>;
  _max?: Maybe<SchemaNameMaxOrderByAggregateInput>;
  _min?: Maybe<SchemaNameMinOrderByAggregateInput>;
  _sum?: Maybe<SchemaNameSumOrderByAggregateInput>;
  attesterAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCreator?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
};

export type SchemaNameOrderByWithRelationInput = {
  attesterAddress?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isCreator?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  schema?: Maybe<SchemaOrderByWithRelationInput>;
  schemaId?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
};

export enum SchemaNameScalarFieldEnum {
  AttesterAddress = 'attesterAddress',
  Id = 'id',
  IsCreator = 'isCreator',
  Name = 'name',
  SchemaId = 'schemaId',
  Time = 'time'
}

export type SchemaNameScalarWhereInput = {
  AND?: Maybe<Array<SchemaNameScalarWhereInput>>;
  NOT?: Maybe<Array<SchemaNameScalarWhereInput>>;
  OR?: Maybe<Array<SchemaNameScalarWhereInput>>;
  attesterAddress?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  isCreator?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  schemaId?: Maybe<StringFilter>;
  time?: Maybe<IntFilter>;
};

export type SchemaNameScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SchemaNameScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SchemaNameScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SchemaNameScalarWhereWithAggregatesInput>>;
  attesterAddress?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isCreator?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  schemaId?: Maybe<StringWithAggregatesFilter>;
  time?: Maybe<IntWithAggregatesFilter>;
};

export type SchemaNameSumAggregate = {
  __typename?: 'SchemaNameSumAggregate';
  time?: Maybe<Scalars['Int']>;
};

export type SchemaNameSumOrderByAggregateInput = {
  time?: Maybe<SortOrder>;
};

export type SchemaNameUpdateInput = {
  attesterAddress?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  isCreator?: Maybe<BoolFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  schema?: Maybe<SchemaUpdateOneRequiredWithoutSchemaNamesNestedInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
};

export type SchemaNameUpdateManyMutationInput = {
  attesterAddress?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  isCreator?: Maybe<BoolFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
};

export type SchemaNameUpdateManyWithWhereWithoutSchemaInput = {
  data: SchemaNameUpdateManyMutationInput;
  where: SchemaNameScalarWhereInput;
};

export type SchemaNameUpdateManyWithoutSchemaNestedInput = {
  connect?: Maybe<Array<SchemaNameWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SchemaNameCreateOrConnectWithoutSchemaInput>>;
  create?: Maybe<Array<SchemaNameCreateWithoutSchemaInput>>;
  createMany?: Maybe<SchemaNameCreateManySchemaInputEnvelope>;
  delete?: Maybe<Array<SchemaNameWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SchemaNameScalarWhereInput>>;
  disconnect?: Maybe<Array<SchemaNameWhereUniqueInput>>;
  set?: Maybe<Array<SchemaNameWhereUniqueInput>>;
  update?: Maybe<Array<SchemaNameUpdateWithWhereUniqueWithoutSchemaInput>>;
  updateMany?: Maybe<Array<SchemaNameUpdateManyWithWhereWithoutSchemaInput>>;
  upsert?: Maybe<Array<SchemaNameUpsertWithWhereUniqueWithoutSchemaInput>>;
};

export type SchemaNameUpdateWithWhereUniqueWithoutSchemaInput = {
  data: SchemaNameUpdateWithoutSchemaInput;
  where: SchemaNameWhereUniqueInput;
};

export type SchemaNameUpdateWithoutSchemaInput = {
  attesterAddress?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  isCreator?: Maybe<BoolFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
};

export type SchemaNameUpsertWithWhereUniqueWithoutSchemaInput = {
  create: SchemaNameCreateWithoutSchemaInput;
  update: SchemaNameUpdateWithoutSchemaInput;
  where: SchemaNameWhereUniqueInput;
};

export type SchemaNameWhereInput = {
  AND?: Maybe<Array<SchemaNameWhereInput>>;
  NOT?: Maybe<Array<SchemaNameWhereInput>>;
  OR?: Maybe<Array<SchemaNameWhereInput>>;
  attesterAddress?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  isCreator?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  schema?: Maybe<SchemaRelationFilter>;
  schemaId?: Maybe<StringFilter>;
  time?: Maybe<IntFilter>;
};

export type SchemaNameWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type SchemaOrderByWithAggregationInput = {
  _avg?: Maybe<SchemaAvgOrderByAggregateInput>;
  _count?: Maybe<SchemaCountOrderByAggregateInput>;
  _max?: Maybe<SchemaMaxOrderByAggregateInput>;
  _min?: Maybe<SchemaMinOrderByAggregateInput>;
  _sum?: Maybe<SchemaSumOrderByAggregateInput>;
  creator?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  resolver?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  schema?: Maybe<SortOrder>;
  time?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type SchemaOrderByWithRelationInput = {
  attestations?: Maybe<AttestationOrderByRelationAggregateInput>;
  creator?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  index?: Maybe<SortOrder>;
  resolver?: Maybe<SortOrder>;
  revocable?: Maybe<SortOrder>;
  schema?: Maybe<SortOrder>;
  schemaNames?: Maybe<SchemaNameOrderByRelationAggregateInput>;
  time?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type SchemaRelationFilter = {
  is?: Maybe<SchemaWhereInput>;
  isNot?: Maybe<SchemaWhereInput>;
};

export enum SchemaScalarFieldEnum {
  Creator = 'creator',
  Id = 'id',
  Index = 'index',
  Resolver = 'resolver',
  Revocable = 'revocable',
  Schema = 'schema',
  Time = 'time',
  Txid = 'txid'
}

export type SchemaScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SchemaScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SchemaScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SchemaScalarWhereWithAggregatesInput>>;
  creator?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  index?: Maybe<StringWithAggregatesFilter>;
  resolver?: Maybe<StringWithAggregatesFilter>;
  revocable?: Maybe<BoolWithAggregatesFilter>;
  schema?: Maybe<StringWithAggregatesFilter>;
  time?: Maybe<IntWithAggregatesFilter>;
  txid?: Maybe<StringWithAggregatesFilter>;
};

export type SchemaSumAggregate = {
  __typename?: 'SchemaSumAggregate';
  time?: Maybe<Scalars['Int']>;
};

export type SchemaSumOrderByAggregateInput = {
  time?: Maybe<SortOrder>;
};

export type SchemaUpdateInput = {
  attestations?: Maybe<AttestationUpdateManyWithoutSchemaNestedInput>;
  creator?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  index?: Maybe<StringFieldUpdateOperationsInput>;
  resolver?: Maybe<StringFieldUpdateOperationsInput>;
  revocable?: Maybe<BoolFieldUpdateOperationsInput>;
  schema?: Maybe<StringFieldUpdateOperationsInput>;
  schemaNames?: Maybe<SchemaNameUpdateManyWithoutSchemaNestedInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SchemaUpdateManyMutationInput = {
  creator?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  index?: Maybe<StringFieldUpdateOperationsInput>;
  resolver?: Maybe<StringFieldUpdateOperationsInput>;
  revocable?: Maybe<BoolFieldUpdateOperationsInput>;
  schema?: Maybe<StringFieldUpdateOperationsInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SchemaUpdateOneRequiredWithoutAttestationsNestedInput = {
  connect?: Maybe<SchemaWhereUniqueInput>;
  connectOrCreate?: Maybe<SchemaCreateOrConnectWithoutAttestationsInput>;
  create?: Maybe<SchemaCreateWithoutAttestationsInput>;
  update?: Maybe<SchemaUpdateWithoutAttestationsInput>;
  upsert?: Maybe<SchemaUpsertWithoutAttestationsInput>;
};

export type SchemaUpdateOneRequiredWithoutSchemaNamesNestedInput = {
  connect?: Maybe<SchemaWhereUniqueInput>;
  connectOrCreate?: Maybe<SchemaCreateOrConnectWithoutSchemaNamesInput>;
  create?: Maybe<SchemaCreateWithoutSchemaNamesInput>;
  update?: Maybe<SchemaUpdateWithoutSchemaNamesInput>;
  upsert?: Maybe<SchemaUpsertWithoutSchemaNamesInput>;
};

export type SchemaUpdateWithoutAttestationsInput = {
  creator?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  index?: Maybe<StringFieldUpdateOperationsInput>;
  resolver?: Maybe<StringFieldUpdateOperationsInput>;
  revocable?: Maybe<BoolFieldUpdateOperationsInput>;
  schema?: Maybe<StringFieldUpdateOperationsInput>;
  schemaNames?: Maybe<SchemaNameUpdateManyWithoutSchemaNestedInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SchemaUpdateWithoutSchemaNamesInput = {
  attestations?: Maybe<AttestationUpdateManyWithoutSchemaNestedInput>;
  creator?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  index?: Maybe<StringFieldUpdateOperationsInput>;
  resolver?: Maybe<StringFieldUpdateOperationsInput>;
  revocable?: Maybe<BoolFieldUpdateOperationsInput>;
  schema?: Maybe<StringFieldUpdateOperationsInput>;
  time?: Maybe<IntFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SchemaUpsertWithoutAttestationsInput = {
  create: SchemaCreateWithoutAttestationsInput;
  update: SchemaUpdateWithoutAttestationsInput;
};

export type SchemaUpsertWithoutSchemaNamesInput = {
  create: SchemaCreateWithoutSchemaNamesInput;
  update: SchemaUpdateWithoutSchemaNamesInput;
};

export type SchemaWhereInput = {
  AND?: Maybe<Array<SchemaWhereInput>>;
  NOT?: Maybe<Array<SchemaWhereInput>>;
  OR?: Maybe<Array<SchemaWhereInput>>;
  attestations?: Maybe<AttestationListRelationFilter>;
  creator?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  index?: Maybe<StringFilter>;
  resolver?: Maybe<StringFilter>;
  revocable?: Maybe<BoolFilter>;
  schema?: Maybe<StringFilter>;
  schemaNames?: Maybe<SchemaNameListRelationFilter>;
  time?: Maybe<IntFilter>;
  txid?: Maybe<StringFilter>;
};

export type SchemaWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type ServiceStat = {
  __typename?: 'ServiceStat';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ServiceStatCountAggregate = {
  __typename?: 'ServiceStatCountAggregate';
  _all: Scalars['Int'];
  name: Scalars['Int'];
  value: Scalars['Int'];
};

export type ServiceStatCountOrderByAggregateInput = {
  name?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ServiceStatCreateInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ServiceStatCreateManyInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ServiceStatGroupBy = {
  __typename?: 'ServiceStatGroupBy';
  _count?: Maybe<ServiceStatCountAggregate>;
  _max?: Maybe<ServiceStatMaxAggregate>;
  _min?: Maybe<ServiceStatMinAggregate>;
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ServiceStatMaxAggregate = {
  __typename?: 'ServiceStatMaxAggregate';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ServiceStatMaxOrderByAggregateInput = {
  name?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ServiceStatMinAggregate = {
  __typename?: 'ServiceStatMinAggregate';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ServiceStatMinOrderByAggregateInput = {
  name?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ServiceStatOrderByWithAggregationInput = {
  _count?: Maybe<ServiceStatCountOrderByAggregateInput>;
  _max?: Maybe<ServiceStatMaxOrderByAggregateInput>;
  _min?: Maybe<ServiceStatMinOrderByAggregateInput>;
  name?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type ServiceStatOrderByWithRelationInput = {
  name?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export enum ServiceStatScalarFieldEnum {
  Name = 'name',
  Value = 'value'
}

export type ServiceStatScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ServiceStatScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ServiceStatScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ServiceStatScalarWhereWithAggregatesInput>>;
  name?: Maybe<StringWithAggregatesFilter>;
  value?: Maybe<StringWithAggregatesFilter>;
};

export type ServiceStatUpdateInput = {
  name?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ServiceStatUpdateManyMutationInput = {
  name?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ServiceStatWhereInput = {
  AND?: Maybe<Array<ServiceStatWhereInput>>;
  NOT?: Maybe<Array<ServiceStatWhereInput>>;
  OR?: Maybe<Array<ServiceStatWhereInput>>;
  name?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type ServiceStatWhereUniqueInput = {
  name?: Maybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedStringFilter>;
  _min?: Maybe<NestedStringFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type Timestamp = {
  __typename?: 'Timestamp';
  from: Scalars['String'];
  id: Scalars['String'];
  timestamp: Scalars['Int'];
  tree: Scalars['String'];
  txid: Scalars['String'];
};

export type TimestampAvgAggregate = {
  __typename?: 'TimestampAvgAggregate';
  timestamp?: Maybe<Scalars['Float']>;
};

export type TimestampAvgOrderByAggregateInput = {
  timestamp?: Maybe<SortOrder>;
};

export type TimestampCountAggregate = {
  __typename?: 'TimestampCountAggregate';
  _all: Scalars['Int'];
  from: Scalars['Int'];
  id: Scalars['Int'];
  timestamp: Scalars['Int'];
  tree: Scalars['Int'];
  txid: Scalars['Int'];
};

export type TimestampCountOrderByAggregateInput = {
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  tree?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type TimestampCreateInput = {
  from: Scalars['String'];
  id: Scalars['String'];
  timestamp: Scalars['Int'];
  tree?: Maybe<Scalars['String']>;
  txid: Scalars['String'];
};

export type TimestampCreateManyInput = {
  from: Scalars['String'];
  id: Scalars['String'];
  timestamp: Scalars['Int'];
  tree?: Maybe<Scalars['String']>;
  txid: Scalars['String'];
};

export type TimestampGroupBy = {
  __typename?: 'TimestampGroupBy';
  _avg?: Maybe<TimestampAvgAggregate>;
  _count?: Maybe<TimestampCountAggregate>;
  _max?: Maybe<TimestampMaxAggregate>;
  _min?: Maybe<TimestampMinAggregate>;
  _sum?: Maybe<TimestampSumAggregate>;
  from: Scalars['String'];
  id: Scalars['String'];
  timestamp: Scalars['Int'];
  tree: Scalars['String'];
  txid: Scalars['String'];
};

export type TimestampMaxAggregate = {
  __typename?: 'TimestampMaxAggregate';
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Int']>;
  tree?: Maybe<Scalars['String']>;
  txid?: Maybe<Scalars['String']>;
};

export type TimestampMaxOrderByAggregateInput = {
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  tree?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type TimestampMinAggregate = {
  __typename?: 'TimestampMinAggregate';
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Int']>;
  tree?: Maybe<Scalars['String']>;
  txid?: Maybe<Scalars['String']>;
};

export type TimestampMinOrderByAggregateInput = {
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  tree?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type TimestampOrderByWithAggregationInput = {
  _avg?: Maybe<TimestampAvgOrderByAggregateInput>;
  _count?: Maybe<TimestampCountOrderByAggregateInput>;
  _max?: Maybe<TimestampMaxOrderByAggregateInput>;
  _min?: Maybe<TimestampMinOrderByAggregateInput>;
  _sum?: Maybe<TimestampSumOrderByAggregateInput>;
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  tree?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export type TimestampOrderByWithRelationInput = {
  from?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  timestamp?: Maybe<SortOrder>;
  tree?: Maybe<SortOrder>;
  txid?: Maybe<SortOrder>;
};

export enum TimestampScalarFieldEnum {
  From = 'from',
  Id = 'id',
  Timestamp = 'timestamp',
  Tree = 'tree',
  Txid = 'txid'
}

export type TimestampScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TimestampScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TimestampScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TimestampScalarWhereWithAggregatesInput>>;
  from?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  timestamp?: Maybe<IntWithAggregatesFilter>;
  tree?: Maybe<StringWithAggregatesFilter>;
  txid?: Maybe<StringWithAggregatesFilter>;
};

export type TimestampSumAggregate = {
  __typename?: 'TimestampSumAggregate';
  timestamp?: Maybe<Scalars['Int']>;
};

export type TimestampSumOrderByAggregateInput = {
  timestamp?: Maybe<SortOrder>;
};

export type TimestampUpdateInput = {
  from?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  timestamp?: Maybe<IntFieldUpdateOperationsInput>;
  tree?: Maybe<StringFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type TimestampUpdateManyMutationInput = {
  from?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  timestamp?: Maybe<IntFieldUpdateOperationsInput>;
  tree?: Maybe<StringFieldUpdateOperationsInput>;
  txid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type TimestampWhereInput = {
  AND?: Maybe<Array<TimestampWhereInput>>;
  NOT?: Maybe<Array<TimestampWhereInput>>;
  OR?: Maybe<Array<TimestampWhereInput>>;
  from?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  timestamp?: Maybe<IntFilter>;
  tree?: Maybe<StringFilter>;
  txid?: Maybe<StringFilter>;
};

export type TimestampWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type AttestationsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AttestationsQuery = { __typename?: 'Query', getAttestation?: { __typename?: 'Attestation', id: string, revoked: boolean, recipient: string, attester: string, decodedDataJson: string, timeCreated: number, refUID: string } | null | undefined };


export const AttestationsDocument = `
    query attestations($id: String!) {
  getAttestation(where: {id: $id}) {
    id
    revoked
    recipient
    attester
    decodedDataJson
    timeCreated
    refUID
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    attestations: build.query<AttestationsQuery, AttestationsQueryVariables>({
      query: (variables) => ({ document: AttestationsDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useAttestationsQuery, useLazyAttestationsQuery } = injectedRtkApi;

